import { AlertTriangle } from "lucide-react";
import { ErrorState } from "@/components/shared/error-state";
import { isNosUnavailable } from "@/hooks/use-demands";

/**
 * A report's load error. When NOS itself is unreachable or not set up for this
 * environment, say so plainly — the rest of the app still works — instead of showing the
 * Gateway's raw message as if the report were broken.
 */
export function ReportError({ error, onRetry }: { error: Error; onRetry: () => void }) {
  if (isNosUnavailable(error)) {
    return (
      <div className="flex items-start gap-2 rounded-md border border-warning-200 bg-warning-50 px-4 py-3 text-sm text-warning-950">
        <AlertTriangle className="mt-0.5 size-4 shrink-0" aria-hidden />
        <span>
          NOS isn't connected in this environment, so these hours can't be loaded. The rest of the
          app works as normal. ({error.message})
        </span>
      </div>
    );
  }
  return <ErrorState message={error.message} onRetry={onRetry} />;
}
